import React from 'react';
import RMSCommonDialog from '../../../shared/components/dialog/RMSCommonDialog';
import EvidencePreferencesPage from '../../pages/EvidencePreferencesPage';

const EvidencePreferenceDialog = ({ close }) => (
  <RMSCommonDialog
    open
    title="Evidence Preference"
    onClose={close}
    maxWidth="md"
    fullWidth
    closeOnBackdropClick={false}
    saveButton={{ show: false }}
    cancelButton={{ show: false }}
    dialogClassName="evidence-preference-dialog">
    <EvidencePreferencesPage />
  </RMSCommonDialog>
);

export default EvidencePreferenceDialog;
